// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"2ac101db","488":"0b82b1da"}[chunkId] + ".chunk.js";
};